import * as types from './types';
import Vue from 'vue';
// 模块
// eslint-disable-next-line import/no-cycle
import qqCrowdBox from './qqCrowdBox/index';
import Request from '@/lib/request';
import Api from '@/apis/invite/index';
import authManageApi from '@/apis/authManage/index';
import { get } from 'lodash';

export default {
  namespaced: true,
  state: {
    userList: {
      all: [],
      data: [],
      pageInfo: {
        page: 1,
        count: 10,
        total: 0,
        operatorTotal: 0,
      },
    },
    inviteCode: '',
    roleList: [],
    unreadNum: 0,
    unbindUserList: [], // 申请解绑的达人列表
  },
  mutations: {
    [types.SET_USER_LIST](state, {
      list = state.userList.data,
      all = state.userList.all,
    }) {
      state.userList.data = list;
      state.userList.all = all;
    },
    [types.SET_USER_LIST_PAGE_INFO](state, payload = {}) {
      state.userList.pageInfo = {
        ...state.userList.pageInfo,
        ...payload,
      };
    },
    [types.SET_INVITE_CODE](state, {
      code,
    }) {
      state.inviteCode = code;
    },
    [types.SET_ROLE_LIST](state, {
      list,
    }) {
      state.roleList = list;
    },
  },
  actions: {
    async fetchAllUserList({
      commit,
      state,
    }) {
      const reqData = {
        page: 1,
        count: 1000,
      };
      const res = await authManageApi.getEmployeeList(reqData);
      if (Number(res?.head?.code) !== 0) return;

      commit(types.SET_USER_LIST, {
        all: res?.user_list || [],
      });
      state.unbindUserList = res?.unbinding_user_list || [];
    },

    async fetchUserList({
      commit,
      state,
    }) {
      const { page, count } = state.userList.pageInfo;
      const reqData = { page, count };
      const res = await authManageApi.getEmployeeList(reqData);
      if (Number(res?.head?.code) !== 0) return;

      commit(types.SET_USER_LIST, {
        list: res?.user_list || [],
      });
      commit(types.SET_USER_LIST_PAGE_INFO, {
        total: res?.page_info?.total || 0,
        operatorTotal: res?.page_info?.operator_total || 0,
      });
    },

    async fetchInviteCode({
      commit,
      rootState,
    }, {
      userId,
    } = {}) {
      try {
        const reqData = {
          user_id: String(userId || rootState.userCenter.profile.user_id),
          uid: String(rootState.userCenter.profile.uid),
        };
        const res = await Api.inviteGetCode(reqData);
        const code = Number(res?.head?.code);
        if (code !== 0) {
          const errorMsg = `[${code}] 获取邀请链接失败：${res?.head?.msg}`;
          Vue.prototype.$tip.error(errorMsg);
          return;
        };

        commit(types.SET_INVITE_CODE, {
          code: res.code,
        });
      } catch (err) {
        const errorMsg = `[${err?.code}] 获取邀请链接失败：${err?.message}`;
        Vue.prototype.$tip.error(errorMsg);
      }
    },

    async fetchRoleList({
      commit,
    }) {
      const res = await authManageApi.getRoleList({});
      if (Number(res?.head?.code) !== 0) return;

      commit(types.SET_ROLE_LIST, {
        list: res?.role_list || [],
      });
    },

    // 设置未读数量
    async setUnreadNum({ state, rootState }) {
      if (rootState.userCenter.profile.identity !== 1 || rootState.userCenter.profile.role !== 100) {
        return;
      }
      let res;
      let list = [];
      try {
        res = await Request({
          url: 'v3/manage/unbind/query',
          method: 'post',
          data: {},
        });
      } catch (error) {
      } finally {
        if (Number(get(res, 'head.code')) === 0) {
          list = get(res, 'application_list') || [];
        }
        // 计算达人已提交的处理数量
        state.unreadNum = get(res, 'process_count') || '';
      }
      return list;
    },
  },
  getters: {
    canDelieveRoleList(state, getters, rootState) {
      const {
        role,
        identity,
      } = rootState.userCenter.profile;
      const fList = state.roleList.filter(item => item.role === 200 || item.role === 300 || item.role === 201);
      let rList = [];
      // 管理员
      if (role === 100) {
        if (identity === 0) {
          // 个人
          rList = fList.filter(item => item.role === 200 || item.role === 201);
        } else if (identity === 1) {
          // 企业
          rList = fList;
        }
      } else if (role === 200) {
        // 运营
        rList = fList.filter(item => item.role === 300 || item.role === 201);
      } else if (role === 300) {
        return [];
      } else if (role === 201) {
        return [];
      }

      return rList.map(item => ({
        label: item.role_name,
        value: item.role,
      }));
    },
    filterUserList(state, getters, rootState) {
      const {
        role,
      } = rootState.userCenter.profile;
      if (role === 0) return [];
      if (role === 100) return state.userList.data;
      if (role === 200 || role === 201) {
        // eslint-disable-next-line max-len
        return state.userList.data.filter(user => user.role === 0 || user.role === 200 || user.role === 300 || user.role === 201);
      }

      if (role === 300) {
        return state.userList.data.filter(user => user.role === 300);
      }

      return state.userList.data;
    },
  },
  modules: {
    qqCrowdBox,
  },
};
